import { createSlice } from "@reduxjs/toolkit";

const modal = createSlice({
  name: "modals",
  initialState: {
    productViewModal: false,
    loginModal: false,
    searchModal: false,
    wishListModal: false,
    cartModal: false,
  },
  reducers: {
    openModal: (state, action) => {
      state[action.payload] = true;
    },
    closeModal: (state, action) => {
      state[action.payload] = false;
    },
  },
});

export const { openModal, closeModal } = modal.actions;
export default modal.reducer;
